module.exports = __webpack_public_path__ + "static/media/working-capital-loan.bed95c64.png";